import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useRecordsList() {
  // Use toast
  const toast = useToast();

  const refRecordListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "ID", sortable: true },
    { key: "supplier.company_name_cn", label: "中獎公司 " },
    { key: "reward_title", stickyColumn: true, label: "獎品名稱", sortable: true},
    { key: "reward_description", label: "獎品詳情", sortable: true },
    { key: "amount", label: "獎品價值 ", sortable: true },
    { key: "created_at", label: "中獎時間" },
  ];
  const perPage = ref(10);
  const totalRecords = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refRecordListTable.value
      ? refRecordListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRecords.value,
    };
  });

  const refetchData = () => {
    refRecordListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchRecords = (ctx, callback) => {
    store
      .dispatch("app-record/fetchWheelGetAwardList", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { rewards, total } = response.data;
        callback(rewards);
        totalRecords.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching record list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    fetchRecords,
    tableColumns,
    perPage,
    currentPage,
    totalRecords,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refRecordListTable,
    ability,
    refetchData,
  };
}
